module.exports = __webpack_public_path__ + "static/img/appdow_bk3_icon.98bb901.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk3_icon.png
// module id = MHms
// module chunks = 4